import React from 'react';
import { observer } from 'mobx-react';
import { isStateTreeNode, getType } from 'mobx-state-tree';
import { ConfigurationSchema } from '@jbrowse/core/configuration';
export { default as stateModelFactory } from './model';
export var configSchema = ConfigurationSchema('ConfigurationEditorWidget', {});
export var HeadingComponent = observer(function (_ref) {
  var model = _ref.model;
  if (model === null || model === void 0 ? void 0 : model.target) {
    if (model.target.type) {
      return React.createElement(React.Fragment, null, "".concat(model.target.type, " settings"));
    }
    if (isStateTreeNode(model.target)) {
      var type = getType(model.target);
      if (type === null || type === void 0 ? void 0 : type.name) {
        return React.createElement(React.Fragment, null, "".concat(type.name.replace('ConfigurationSchema', ''), " settings"));
      }
    }
  }
  return React.createElement(React.Fragment, null, "Settings");
});